import { hasAncestorWithClasses } from "../../utils/hasAncestorOfClass";
import preprocessorQuery from "../../utils/preprocessorQuery";

const canListItemDragByLocks = (itemIndex, listSize, lockTopItemForDrag, lockBottomItemForDrag) =>
  !((lockTopItemForDrag && itemIndex === 0) || (lockBottomItemForDrag && itemIndex === listSize - 1));

const modalClassNameArray = ["modal", preprocessorQuery.isIos() ? "ios" : ""];

const modalClassName = modalClassNameArray.join(" ");

// Note: when having multiple classes names, should use hasAncestorWithClasses with the names array
// instead of hasAncestorOfClass
const clickWasOnModalView = e => hasAncestorWithClasses(e.target, modalClassNameArray);

export { canListItemDragByLocks, clickWasOnModalView, modalClassName };
